import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { getUserAgent } from '@uploadcare/upload-client';
import { PACKAGE_VERSION, PACKAGE_NAME } from '../../env.js';

/**
 * @param {import('@uploadcare/upload-client').CustomUserAgentOptions} options
 * @returns {ReturnType<import('@uploadcare/upload-client').CustomUserAgentFn>}
 */
export function customUserAgent(options) {
  return getUserAgent(_objectSpread(_objectSpread({}, options), {}, {
    libraryName: PACKAGE_NAME,
    libraryVersion: PACKAGE_VERSION
  }));
}